<template>
    <li class="card card--backed card--colour-white card--fixed card--standard card--blog card--ambition">
        <a class="card__inner" :href="url">
            <div class="card__body">
                <div class="card__image">
                    <img :src="image_url" :alt="title">
                </div>
                <div class="card__text">
                    <div class="card__title h3">{{ title }}</div>
                </div>
            </div>
            <div class="card__footer panel panel--white">
                <div class="button button--small  button--swipe button--white button--transparent">
                    <div class="button__background"></div>
                    <div class="button__icon-wrapper">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="37.928" height="38.97" viewBox="0 0 37.928 38.97">
                            <defs>
                                <clipPath id="clip-path">
                                    <rect id="Rectangle_45" data-name="Rectangle 45" width="38.97" height="37.928" stroke-width="4"></rect>
                                </clipPath>
                            </defs>
                            <g id="arrow-right" transform="translate(0 38.97) rotate(-90)">
                                <g id="Group_71" data-name="Group 71" transform="translate(0 0)" clip-path="url(#clip-path)">
                                    <path id="Line_25" data-name="Line 25" d="M9.609,33.113H0V0H9.609Z" transform="translate(14.68 0)"></path>
                                    <path id="Path_9" data-name="Path 9" d="M17.039,20.5,0,7.677,5.779,0,19.836,10.582,32.933.089l6.009,7.5L22.933,20.415Z" transform="translate(-0.035 18.804)"></path>
                                </g>
                            </g>
                        </svg>
                    </div>
                    <span>Read more</span>
                </div>
            </div>
        </a>
    </li>
</template>

<script>
export default {
    props: {
        image_url: String,
        title: String,
        url: String
    }
}
</script>
